// import React from "react";

// const Modal = ({ imageUrl, onNext, onPrev, onCancel }) => {
//     return (
//         <div className="modal" onClick={onCancel}>
//             <div className="modal-content" onClick={(e) => e.stopPropagation()}>
//                 <img src={imageUrl} alt="modal-img" />
//                 <button className="prev" onClick={onPrev}>&#10094;</button>
//                 <button className="next" onClick={onNext}>&#10095;</button>
//             </div>
//         </div>
//     );
// };

// export default Modal;
import React from "react";

const Modal = ({ imageUrl, onNext, onPrev, onCancel }) => {
    return (
        <div className="mfp-wrap mfp-gallery mfp-close-btn-in mfp-auto-cursor mfp-ready" tabIndex="-1" style={{ overflow: "hidden auto", backgroundColor: "#000000bb" }}>
            <div className="mfp-container mfp-s-ready mfp-image-holder">
                <div className="mfp-content">
                    <div className="mfp-figure">
                        <button title="Close (Esc)" type="button" className="mfp-close" onClick={onCancel}>&times;</button>
                        <figure>
                            <img className="mfp-img" src={imageUrl} alt="modal-img" style={{ maxHeight: "424px" }} />
                        </figure>
                    </div>
                </div>
                <div className="mfp-preloader">Loading...</div>
                <button title="Previous (Left arrow key)" type="button" className="mfp-arrow mfp-arrow-left mfp-prevent-close" onClick={onPrev}></button>
                <button title="Next (Right arrow key)" type="button" className="mfp-arrow mfp-arrow-right mfp-prevent-close" onClick={onNext}></button>
            </div>
        </div>
    );
};

export default Modal;
